<template>
    <div>
        <v-card flat>
            <v-toolbar-title class="tituloMaquinaria text-center">Registro de Incidentes de Maquinarias</v-toolbar-title>            
            <v-toolbar flat title>
                <v-divider vertical class="ml-3"></v-divider>    

                <v-spacer></v-spacer>      
                <v-text-field outlined class=" pr-4"
                    label="Buscar Maquinaria"
                    v-model="buscarMaquinaria"
                    append-icon="mdi-magnify"
                    single-line
                    hide-details
                ></v-text-field>
            </v-toolbar>
            <v-data-table
                dense
                :headers="EncabezadoTablaMaquinarias"
                :items="ArrayTodasMaquinarias"
                :search="buscarMaquinaria"
                item-key=""
                class="elevation-1"
                :footer-props="{itemsPerPageText: 'Filas por página'}"                 
                :loading="loading"
                loading-text="Cargando Datos..."                
            >
            <!-- mostramos los botones que apareceran en cada registro de la tabla -->
                <template v-slot:item.action="{ item }">
                    <v-tooltip bottom color="#0019d8" v-if="permisos.crear">
                        <template v-slot:activator="{ on }">
                            <v-btn small color="#0019d8" dark outlined icon v-on="on" @click="AbrirDialogoRegistroDeIncidentes(item)">
                                <v-icon>fas fa-car-crash</v-icon>
                            </v-btn>
                        </template>
                        <span>Registrar Incidente</span>
                    </v-tooltip>                                          
                    <v-tooltip left color="#d69b01">
                        <template v-slot:activator="{ on }">
                            <v-btn small class="ml-2" dark outlined icon color="#d69b01" v-on="on" @click="MostrarIncidenteMaquinaria(item)">
                                <v-icon small>fas fa-eye</v-icon>
                            </v-btn>                        
                        </template>
                        <span>Ver Incidente de la Maquinaria</span>
                    </v-tooltip>                                              
                </template>
            <!-- mostramos un mensaje si no se encuentran datos en la BD        -->
                <template v-slot:no-data v-if="ArrayTodasMaquinarias.length === 0">
                    <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left" v-if="!alertError">
                        No existen maquinarias registradas
                    </v-alert>
                    <v-alert dense outlined type="error" v-if="alertError">
                        No fue posible la comunicación con <strong>API SERVICE</strong> ponganse en contacto con el administrador si este mensaje persiste.
                    </v-alert>
                </template>                
                <template v-slot:no-results>
                    <v-alert dense outlined class="text-xs-center textoalerta" type="warning" prominent border="left"
                    >
                        No existen datos registrados
                    </v-alert>
                </template> 
            </v-data-table>    
        </v-card>
        <RegistrarIncidenteDeMaquinaria
            :DialogoRegistroDeIncidentes="DialogoRegistroDeIncidentes" @CerrarDialogo="CerrarDialogoRegistroDeIncidentes"
            :Titulo="Titulo" :DataMaquinaria="DataMaquinaria"
        />
    </div>
</template>

<script>
import { showMessageError, showMessageSuccess } from '../../../services/sweetAlert'
import RegistrarIncidenteDeMaquinaria from '../../../components/Mantenimiento/Maquinarias/RegistrarIncidenteDeMaquinaria'
import { mapGetters, mapActions  } from 'vuex'

export default {
    components: {
        RegistrarIncidenteDeMaquinaria,
    },

    data() {
        return {
            sucursalesAsignadas:[],
            sucursalBodegas:[],
            bodega:0,
            bodegaId:0,
            sucursal:0, 

            alertError:false,
            EsNuevo: false,
            Titulo: '',
            loading: false,
            buscarMaquinaria: '',
            EncabezadoTablaMaquinarias:[
                {text: 'Id', value: 'idMaquinaria', align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},   
                {text: 'Nombre', value: 'nombre', align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Código', value: 'codigo', align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},
                {text: 'Tipo', value: 'tipoMaquinaria.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},
                {text: 'Serie', value: 'serie', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},
                {text: 'Propietario', value: 'propietario', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Proyecto Actual', value: 'proyecto.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Estado', value: 'estadoMaquinaria.nombre', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
                {text: 'Acciones', value: 'action', sortable: false, align: 'center', divider: 'true', class: 'tituloTablaSubMenu'},                                
            ],       
            ArrayTodasMaquinarias:[],
            DialogoRegistroDeIncidentes: false,
            DataMaquinaria:{
                idMaquinaria:'',
                tipo: '',
                marca:'',
                placa:'',
                propietario:''
            },

            //variables para los permisos del colaborador
            namespace:'oidcStore/',
            permisos:{
                crear:false,
                editar:false,
                eliminar:false
            },         
            EstadoPermisoEditar: true, 
        }
    },

    computed: {
        ...mapGetters('oidcStore', [
            'oidcIsAuthenticated',
            'oidcUser'
        ]),      
    },    

    created() {
        this.ObtenerPermisosSubmenuUsuario()
        this.TodasMaquinarias()
    },

    methods: {
        seleccionarBodega(){
            //si ha seleccionado una sucursal y proyecto
            if(this.sucursal != '' && this.bodega != ''){
                this.activeActions=false
                this.bodegaId=this.bodega
                this.TodasMaquinarias()
            }
        },
        seleccionarSucursal(){
            this.bodega = 0
            this.sucursalesAsignadas.forEach(suc => {
                if(suc.sucursalId == this.sucursal){
                    this.sucursalBodegas = suc.bodegas
                }
            })
        }, 
        /*       
        async obtenerSucursalesAsignadas(){
            const response  = await this.$store.dispatch('misSucursales')
            if(response === undefined){
                showMessageError('No fue posible obtener las sucursales asignadas')
                return
            }else if(response.status === 200){
                this.sucursalesAsignadas = response.data
            }
        },*/          
        // metodos para obtener los permisos del colaborador a este modulo
        ...mapActions('oidcStore', ['authenticateOidcSilent',
                'signOutOidc', 'authenticateOidc']),

        ControllerException(){
            this.alertError=true
            this.loading=false
        },
            async ObtenerPermisosSubmenuUsuario(role){
            if (this.$store.getters[this.namespace + 'oidcIsAuthenticated']) {
                if(this.$store.getters['oidcStore/oidcUser'].role === 'Administrador'){
                        this.permisos.crear = true
                        this.permisos.editar = true
                        this.permisos.eliminar = true
                        return 0            
                }else{
                    //preguntar al backend por los permisos del submenu del usuario
                        var url = 'maquinariamantenimiento'
                        const response  = await this.$store.dispatch('PermisosSubMenu', url)
                        if(typeof response === 'undefined'){
                            this.ControllerException()
                            return 0
                        }

                        if(response.status === 200){
                            this.alertError= false
                            this.permisos = response.data      
                            // console.log(this.permisos)   
                        }else if(response.status === 400){
                            showMessageError('Error 400','Petición mala')
                        }else if(response.status === 401){
                            showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')
                        }else if(response.status === 404){
                            showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                        }else if(response.status === 500){
                            showMessageError('Error 500','Error en el servidor')            
                        }
                        return 0
                }
            }
            },

        //obtenemos todos las maquinarias creadas y lo mostramos en la tabla
            async TodasMaquinarias(){
                this.loading = true
                var data = {idEstado : 1, bodega:0, sucursal:0} 
                const response = await this.$store.dispatch('ObtenerTodasMaquinarias', data)
                if(typeof response === 'undefined'){
                    this.ControllerException()
                    return 0
                }
                if(response.status === 200){
                    this.alertError= false
                    this.ArrayTodasMaquinarias = response.data
                    this.loading = false
                }else if(response.status === 400){
                    showMessageError('Error 400','Petición mala')
                    this.loading = false
                }else if(response.status === 401){
                    showMessageError('No Autorizado!','Su usuario no tiene permisos para este módulo')                    
                    this.loading = false
                }else if(response.status === 404){
                    showMessageError('Error 404','El servidor no encontro el recurso solicitado')            
                    this.loading = false
                }else if(response.status === 500){
                    showMessageError('Error 500','Error en el servidor')            
                    this.loading = false
                }
            },
        //abrimos el dialogo con los incidente del vehiculo seleccionado
            AbrirDialogoRegistroDeIncidentes(item){
                if(this.permisos.crear) this.EstadoPermisoEditar = true
                this.Titulo = 'Maquinaria'
                this.EsNuevo = true
                this.DataMaquinaria.idMaquinaria = item.idMaquinaria
                this.DataMaquinaria.tipo = item.tipoMaquinaria.nombre
                this.DataMaquinaria.marca = item.vehiculoMarca.nombre
                this.DataMaquinaria.placa = item.placa
                this.DataMaquinaria.propietario = item.propietario
                this.DialogoRegistroDeIncidentes = true
            },

            CerrarDialogoRegistroDeIncidentes(){
                this.DialogoRegistroDeIncidentes = false
            },
        //mostramos el incidente de la maquinaria seleccionada
            async MostrarIncidenteMaquinaria(item){
                // console.log(item.idMaquinaria)
                this.Titulo = 'Maquinaria'
                this.$router.push('/Mantenimiento/VerIncidente/'+this.Titulo+'/'+item.idMaquinaria)
            },
    },
}
</script>

<style>
    .tituloMaquinaria {
        font-family: 'PT Serif';
        font-size: 25px;        
    }
</style>